import React from 'react';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import { connect } from 'react-redux';
import Tooltip from '@material-ui/core/Tooltip';
import { labelHelper } from '../../../../../helpers/labelHelper';
import LockIcon from '@material-ui/icons/Lock';
import './Inheritage.css';
import SystemLabel from '../../../../../system/SystemLabel/SystemLabel';
import { sourceTypes } from '../../../../../constants/cms/sourceType';

const InheritageWrapper = (props) => {
    const { cms, status, onClick, small } = props;
    if(cms.enviroment === sourceTypes.TEMPLATE && small) return null;
    if (status === true && cms.inheritInfo) return <div className={`inheritage-open-wrapper${small ? '-small' : ''}`} >
        <Tooltip title={labelHelper.getLabel('IsInheritedFromParentEvent')}>
            <div className="inherited-symbol">
                <AccountTreeIcon style={{ fontSize: "17px", color: 'rgb(23, 162, 184)' }} />
            </div>
        </Tooltip >
    </div>;
    if (status === false) return (
        <div className={`inheritage-lock-wrapper${small ? '-small' : ''}`} onClick={onClick}>
            <LockIcon />
            {!small ? <div className="info">
                <h4><SystemLabel name="IsInheritedAndCanNotBeEdited" /></h4>
            </div> : null}
        </div>
    )
    return null;
}
function mapStateToProps(state) {
    return {
        cms: state.cms
    };
}

export default connect(mapStateToProps)(InheritageWrapper);
